import React from 'react'

import { Icon, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { B14 } from '@zet/integration-flow'
import { R14 } from '@zet/integration-flow/components/typography'
import { useUnsafeVariable } from 'nativewind'

export default function EditDetailsListCard({
  onClosePress,
  onEditInfoPress,
}: {
  onClosePress: () => void
  onEditInfoPress: () => void
}) {
  const [colorPrimary150] = useUnsafeVariable('--color-primary-150')

  return (
    <Stack className="bg-primary-10 rounded-lg mx-3 px-3 py-[14px]">
      <XStack className="items-center justify-between mb-2">
        <B14 className="text-[#13002D]">{'Not seeing the right cards?'}</B14>

        <Pressable onPress={onClosePress}>
          <Icon
            name="Close"
            size={20}
            color={colorPrimary150 as string}
            type={'Close'}
          />
        </Pressable>
      </XStack>

      <R14 className="text-[#22004A] mb-2">
        {'Update your details to refresh your card recommendations.'}
      </R14>
      <Pressable
        onPress={onEditInfoPress}
        className="bg-primary-150 rounded-full px-3 py-1 self-start"
      >
        <B14 className="text-white">{'Edit info'}</B14>
      </Pressable>
    </Stack>
  )
}
